import { ShaderNSlizgacz } from '../shaders/legs/shader_n_slizgacz';
import { ProductType } from '@/store/modules/product';
import { ShaderNBox } from '../shaders/legs/shader_n_box';
import { ShaderNOkragla } from '../shaders/legs/shader_n_okagla';
import { ShaderNPlozy } from '../shaders/legs/shader_n_plozy';
import { ShaderNStBox } from '../shaders/legs/shader_n_st_box';
import { ShaderNStGiety } from '../shaders/legs/shader_n_st_giety';
import { ShaderNStProsta } from '../shaders/legs/shader_n_st_prosta';
import { ShaderNStPrzesun } from '../shaders/legs/shader_n_st_przesun';
import { ShaderNStScieta } from '../shaders/legs/shader_n_st_scieta';
import { ShaderNStStozek } from '../shaders/legs/shader_n_st_stozek';
import { ShaderNStozek } from '../shaders/legs/shader_n_stozek';
import { ShaderNWalec } from '../shaders/legs/shader_n_walec';
import { Legs } from './legs';

export const deskLegs = [
    new Legs(
        `b_n_box.gltf`,
        `b_n_box_light.jpg`,
        new ShaderNBox(),
        0,
        ProductType.DESK,
        `biurko_noga_prosta_debowa_icon.jpg`,
    ),
    // new Legs(
    //     `b_n_okragla.gltf`,
    //     `b_n_okragla_light.jpg`,
    //     new ShaderNOkragla(),
    //     0,
    //     ProductType.DESK,
    //     `biurko_noga_metalowa_icon.jpg`,
    // ),
    new Legs(
        `b_n_plozy.gltf`,
        `b_n_plozy_light.jpg`,
        new ShaderNPlozy(),
        0,
        ProductType.DESK,
        `biurko_ploza_metalowa_icon.jpg`,
    ),
    new Legs(
        `b_n_st_box.gltf`,
        `b_n_st_box_light.jpg`,
        new ShaderNStBox(),
        0,
        ProductType.DESK,
        `biurko_stelaz_skosny_drewniany_icon.jpg`,
    ),
    new Legs(
        `b_n_st_giety.gltf`,
        `b_n_st_giety_light.jpg`,
        new ShaderNStGiety(),
        0,
        ProductType.DESK,
        `biurko_stelaz_giety_metalowy_icon.jpg`,
    ),
    new Legs(
        `b_n_st_prosta.gltf`,
        `b_n_st_prosta_light.jpg`,
        new ShaderNStProsta(),
        0,
        ProductType.DESK,
        `biurko_stelaz_prosty_metalowy_icon.jpg`,
    ),
    new Legs(
        `b_n_st_przesun.gltf`,
        `b_n_st_przesun_light.jpg`,
        new ShaderNStPrzesun(),
        0,
        ProductType.DESK,
        `biurko_stelaz_skosny_metalowy_icon.jpg`,
    ),
    new Legs(
        `b_n_st_scieta.gltf`,
        `b_n_st_scieta_light.jpg`,
        new ShaderNStScieta(),
        0,
        ProductType.DESK,
        `biurko_stelaz_skosny_debowy_icon.jpg`,
    ),
    new Legs(
        `b_n_st_stozek.gltf`,
        `b_n_st_stozek_light.jpg`,
        new ShaderNStStozek(),
        0,
        ProductType.DESK,
        `biurko_stelaz_skosny_drewniany_stozek_icon.jpg`,
    ),
    new Legs(
        `b_n_stozek.gltf`,
        `b_n_stozek_light.jpg`,
        new ShaderNStozek(),
        0,
        ProductType.DESK,
        `biurko_noga_stozek_drewniana_icon.jpg`,
    ),
    new Legs(
        `b_n_walec.gltf`,
        `b_n_walec_light.jpg`,
        new ShaderNWalec(),
        0,
        ProductType.DESK,
        `biurko_noga_walec_debowa_icon.jpg`,
    ),
];
